import { type PermissionEntityId } from '@terros/common'
import { type PermGraph, type PermGraphNode } from './types'
import { getPermGraphCarryingEdges } from './permGraphWinningPath'

export function isRenderedPermGraphNode(node: PermGraphNode): boolean {
  return node.kind !== 'defaultRole'
}

export function toRenderedPermGraph(graph: PermGraph): PermGraph {
  const renderedIds = new Set(graph.nodes.filter(isRenderedPermGraphNode).map((node) => node.entityId))
  const applied = graph.nodes.find((node) => node.isAppliedSource)
  const keepsRing = applied === undefined || renderedIds.has(applied.entityId)
  const carrierId = keepsRing ? undefined : toRingCarrierId(graph, renderedIds)

  return {
    nodes: graph.nodes
      .filter(isRenderedPermGraphNode)
      .map((node) => (keepsRing ? node : { ...node, isAppliedSource: node.entityId === carrierId })),
    edges: graph.edges.filter((edge) => renderedIds.has(edge.source) && renderedIds.has(edge.target)),
  }
}

export function toRingCarrierId(
  graph: PermGraph,
  renderedIds: Set<PermissionEntityId>
): PermissionEntityId | undefined {
  const target = graph.nodes.find((node) => node.isTarget)
  if (!target) return

  const nodes = new Map(graph.nodes.map((node) => [node.entityId, node]))

  return getPermGraphCarryingEdges(graph)
    .map((edge) => nodes.get(edge.target))
    .find(
      (node) =>
        node !== undefined &&
        node.entityId !== target.entityId &&
        renderedIds.has(node.entityId) &&
        node.flowScope === target.flowScope
    )?.entityId
}
